'use client';

import { CaseStudyHeader } from './components/CaseStudyHeader';
import { CaseStudyIntro } from './components/CaseStudyIntro';
import { CaseStudySection } from './components/CaseStudySection';
import { Testimonial } from './components/Testimonial';
import { DotBlockEditor } from '../shared/decodeTextBlock';
import { isBlockEditorEmpty } from '@/app/utils';

function SectionEyebrow({ number, label }) {
    return (
        <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-fuschia-400">
            {number}&nbsp;&nbsp;{label}
        </p>
    );
}

export function CaseStudyDetail({ data }) {
    const {
        testimonial,
        solution,
        challenge,
        intro,
        solutionImage,
        resultsImage,
        results,
        client = [],
        industry
    } = data;

    return (
        <main className="text-white" id="case-study" data-component="case-study">
            <CaseStudyHeader {...data} client={client[0]} />

            {/* Overview + sidebar */}
            <div className="container py-16 md:py-20">
                <div className="grid gap-12 md:grid-cols-[1fr_260px]">
                    {!isBlockEditorEmpty(intro) && (
                        <section>
                            <SectionEyebrow number="01" label="Overview" />
                            <div className="mb-5 h-1 w-12 rounded-full bg-fuschia-600" />
                            <DotBlockEditor
                                className="prose max-w-none prose-headings:text-white prose-p:text-slate-300 prose-a:text-fuschia-600 prose-li:text-slate-600"
                                blocks={intro}
                            />
                        </section>
                    )}
                    <CaseStudyIntro client={client[0]} industry={industry} />
                </div>
            </div>

            {/* Challenge — transitional section bridging into the testimonial */}
            {!isBlockEditorEmpty(challenge) && (
                <div
                    className="py-12 md:py-20"
                    style={{
                        background:
                            'linear-gradient(to bottom, transparent 0%, rgba(3, 6, 24, 0.85) 100%)'
                    }}>
                    <div className="container max-w-3xl">
                        <SectionEyebrow number="02" label="Challenge" />
                        <div className="mb-5 h-1 w-12 rounded-full bg-fuschia-600" />
                        <DotBlockEditor
                            className="prose-p:text-lg prose max-w-none prose-headings:text-2xl prose-headings:text-white prose-p:leading-relaxed prose-p:text-slate-200 prose-a:text-fuschia-300 prose-li:text-slate-200"
                            blocks={challenge}
                        />
                    </div>
                </div>
            )}

            {testimonial && testimonial.length > 0 && <Testimonial {...testimonial[0]} />}

            <div className="h-24 bg-gradient-to-b from-blue-800 to-transparent !p-0" />

            {!isBlockEditorEmpty(solution) && (
                <CaseStudySection
                    eyebrow="03  Solution"
                    content={solution}
                    image={solutionImage}
                    alt="Solution image"
                />
            )}

            {!isBlockEditorEmpty(results) && (
                <CaseStudySection
                    eyebrow="04  Results"
                    content={results}
                    image={resultsImage}
                    alt="Results image"
                    imageRight={true}
                />
            )}
        </main>
    );
}
